export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "emailConfirmBar": { "title": "Please confirm that the email <strong>{{ email }}</strong> belongs to you.", "resendButton": "Resend verification email.", "resentText": "Verification email sent.", "resendErrorText": "The verification email failed to send." } } });
};